var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Alert_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9961 7.99805C15.9961 12.4152 12.4152 15.9961 7.99805 15.9961C3.58085 15.9961 0 12.4152 0 7.99805C0 3.58085 3.58085 0 7.99805 0C12.4152 0 15.9961 3.58085 15.9961 7.99805ZM7.99805 9.99756C7.62995 9.99756 7.33154 9.69915 7.33154 9.33105V5.33203C7.33154 4.96393 7.62995 4.66553 7.99805 4.66553C8.36615 4.66553 8.66455 4.96393 8.66455 5.33203V9.33105C8.66455 9.69915 8.36615 9.99756 7.99805 9.99756ZM7.99805 11.9971C8.36615 11.9971 8.66455 11.6987 8.66455 11.3306C8.66455 10.9625 8.36615 10.6641 7.99805 10.6641C7.62995 10.6641 7.33154 10.9625 7.33154 11.3306C7.33154 11.6987 7.62995 11.9971 7.99805 11.9971Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.c4fa5f06.svg";
export { ForwardRef as ReactComponent };